import { PageLocatorMap } from '../types/PageLocatorMap';

export const signUpReturningUserPage = {
  footer: {
    root: 'sign-up-returning-user-page.footer.root',
  },
  form: {
    backButton: 'sign-up-returning-user-page.form.back-button',
    emailInput: 'sign-up-returning-user-page.form.email-input',
    h1: 'sign-up-returning-user-page.form.heading1',
    h2: 'sign-up-returning-user-page.form.heading2',
    phoneInput: 'sign-up-returning-user-page.form.phone-input',
    root: 'sign-up-returning-user-page.form.root',
    signInButton: 'sign-up-returning-user-page.form.sign-in-button',
  },
  header: {
    root: 'sign-up-returning-user-page.header.root',
    signInLink: 'sign-up-returning-user-page.header.sign-in-link',
  },
} as const satisfies PageLocatorMap;
